import * as d3 from 'd3';
import { selectOrAppendDefs } from './index';

export default function() {
  // required parameters
  let chartId;
  let colorScale;
  let valueAccessor;
  let features;
  let svgWidth;
  let svgHeight;

  // optional parameters
  let transitionDuration = 750;
  let width = 20;
  let height = 300;
  let x;
  let rightMargin = 40;
  let steps = 10;

  const chart = function(selection) {
    selection.each(function(data) {
      height = height > svgHeight ? svgHeight - 20 : height;

      const container = d3.select(this);

      let defs = selectOrAppendDefs(container);

      const gradientId = `${chartId}-legend-gradient`;
      let gradient = defs.select(`#${gradientId}`);
      if (gradient.empty()) {
        gradient = defs.append('linearGradient')
          .attr('id', gradientId)
          .attr('x1', '0%')
          .attr('y1', '100%')
          .attr('x2', '0%')
          .attr('y2', '0%')
          .attr('spreadMethod', 'pad')
      }
      gradient.selectAll('*').remove();

      const extent = d3.extent(features, valueAccessor);
      const scale = d3.scaleLinear(extent, [height, 0]);
      const axis = d3.axisRight().scale(scale);

      const addGradientStop = function(percent, value) {
        gradient.append('stop')
          .attr('offset', `${percent * 100}%`)
          .attr('stop-color', colorScale(value))
      };

      addGradientStop(0, extent[0]);
      scale.ticks().forEach(tick => {
        addGradientStop(1 - (scale(tick) / height), tick)
      });
      addGradientStop(1, extent[1]);

      // Coloured bar
      let legend = container.select('.legend');
      const tX = x != null ? x : svgWidth - rightMargin - width;
      const y = (svgHeight - height) / 2;
      if (legend.empty()) {
        legend = container.append('g')
          .attr('class', 'legend');
        legend.append('rect')
          .attr('width', width)
          .attr('height', height)
          .attr('fill', `url(#${gradientId})`)
      }
      legend.select("rect")
        .attr('x', tX)
        .attr('y', y);

      // Ticks
      let axisSel = legend.select('.axis');
      if (axisSel.empty()) {
        axisSel = legend.append('g')
          .attr('class', 'axis')
      }
      axisSel.attr('transform', `translate(${tX + width} ${y})`);

      axisSel.transition()
        .duration(transitionDuration)
        .ease(d3.easeQuadIn)
        .call(axis)
    })
  };

  chart.chartId = function(_) {
    if (!arguments.length) return chartId;
    chartId = _;
    return chart
  };

  chart.colorScale = function(_) {
    if (!arguments.length) return colorScale;
    colorScale = _;
    return chart
  };

  chart.valueAccessor = function(_) {
    if (!arguments.length) return valueAccessor;
    valueAccessor = _;
    return chart
  };

  chart.features = function(_) {
    if (!arguments.length) return features;
    features = _;
    return chart
  };

  chart.svgWidth = function(_) {
    if (!arguments.length) return svgWidth;
    svgWidth = _;
    return chart
  };

  chart.svgHeight = function(_) {
    if (!arguments.length) return svgHeight;
    svgHeight = _;
    return chart
  };

  chart.width = function(_) {
    if (!arguments.length) return width;
    width = _;
    return chart
  };

  chart.height = function(_) {
    if (!arguments.length) return height;
    height = _;
    return chart
  };

  chart.x = function(_) {
    if (!arguments.length) return x;
    x = _;
    return chart
  };

  chart.rightMargin = function(_) {
    if (!arguments.length) return rightMargin;
    rightMargin = _;
    return chart
  };

  chart.steps = function(_) {
    if (!arguments.length) return steps;
    steps = _;
    return chart
  };

  chart.transitionDuration = function (_) {
    if (!arguments.length) return transitionDuration;
    transitionDuration = _;
    return chart;
  };

  return chart
}
